import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {findDOMNode} from 'react-dom';

@inject("store")
@observer
export default class QuestionInfo extends Component {

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.onUpdate && this.props.onUpdate();
    }
    componentDidUpdate() {
        this.props.onUpdate && this.props.onUpdate();
    }

    render() {
        const { store: {
            info, questionCount, question, hasResult
            }
        } = this.props;

        const title = !hasResult ? question : 'Værd at vide';
        const questionNumber = !hasResult ? <span>{questionCount}</span> : null;
        const resultClass = hasResult ? "result" : "";

        return (
            <div className="information">
                <div className="informationText">
                    <h3>
                        {questionNumber ? <span className={"info-index " + resultClass}>{questionNumber}. </span> : null }
                        <span className="info-title">{title}</span>
                    </h3>
                    <div dangerouslySetInnerHTML={{__html: info}}/>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/QuestionInfo.js